module.exports = __webpack_public_path__ + "static/media/download-qr-icon.0fbb6a67.svg";